<div class="verify-modal">
  <ng-container *ngIf="isLoading; else verify" class="iframe-loading-spinner">
    <div style="display: flex; justify-content: center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-container>

  <ng-template #verify>
    <label *ngIf="type === 'email'">{{
      "verification_check_email"| translation
    }}</label>
    <label *ngIf="type === 'phone_number'">{{
      "verification_check_phone"| translation
    }}</label>
    <div class="form-field">
      <input
        #code="ngModel"
        [(ngModel)]="verificationCode"
        pInputText
        [placeholder]="'verification_code'| translation"
        type="text"
      />
    </div>
    <button pButton severity="primary" (click)="sendVerificataion()">
      {{ "submit"| translation }}
    </button>
  </ng-template>
</div>
